.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
}

.link {
  display: flex;
  align-items: center;
  margin-right: 8px;
  font-weight: 300;
  text-decoration: none;
  cursor: pointer;
  color: inherit;
}

.homeLink {
  margin-right: 0;
  /* An active link: the disabled colour was 1.88:1 */
  color: var(--tuna-content-secondary);
}

.separator {
  color: var(--tuna-palette-text-secondary);
}

.nameLink {
  font-size: var(--tuna-typography-fontSize-md);
}
